import { AxiosError, AxiosResponse } from 'axios'

import { CodebaseScope, ScopeToSectionMap } from 'utils/services/errorTrackingService/aggregation'
import { MarkupOptions } from 'utils/services/errorTrackingService/interfaces/MarkupOptions'

import type { BusinessError, ErrorEndpoint } from './types'

export const getMessage = (errors: BusinessError[]) => {
  return errors.reduce((message, error) => `${message}${message ? '|' : ''}${error.message}`, '')
}

export class ResponseError<T extends CodebaseScope = CodebaseScope> extends AxiosError {
  $errors: BusinessError[]
  endpoint: ErrorEndpoint
  scope: T
  section: ScopeToSectionMap[T] | null

  constructor(
    response:
      | AxiosResponse<{
          $errors: BusinessError[]
        }>
      | (AxiosResponse<{
          $errors: BusinessError[]
        }> &
          MarkupOptions<T>),
  ) {
    const message = getMessage(response.data.$errors)

    super(message, AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response)
    this.name = 'ResponseError'
    this.$errors = response.data.$errors
    this.endpoint = response.config.url

    if ('scope' in response && response.scope !== undefined) {
      this.scope = response.scope as T
    } else {
      this.scope = 'root' as T
    }

    if ('section' in response && response.section !== undefined) {
      this.section = response.section as ScopeToSectionMap[T]
    } else {
      this.section = null as ScopeToSectionMap[T]
    }
  }
}

export class InvalidErrorResponseError extends AxiosError {
  endpoint: ErrorEndpoint

  constructor(response: AxiosResponse<{ $errors: BusinessError[] }>) {
    super(
      'Server responded with state=false but response does not contain $errors field',
      AxiosError.ERR_BAD_RESPONSE,
      response.config,
      response.request,
      response,
    )
    this.name = 'InvalidErrorResponseError'
    this.endpoint = response.config.url
  }
}

export class UnhandledBusinessError extends Error {
  error: BusinessError
  endpoint: ErrorEndpoint

  constructor(error: BusinessError, endpoint: ErrorEndpoint) {
    super(error.original_message)

    this.name = 'UnhandledBusinessError'
    this.error = error
    this.endpoint = endpoint
  }
}
